// src/data/placedStudents.js

const placedStudents = [
  {
    id: "P003",
    name: "C. Dhatri",
    image: "/images/PlacedStudents/dhatri.png",
    company: "CWC Big Force Company",
    companyLogo: "/images/PlacedStudents/cwc.png",
    role: null,
    package: "₹12.5 LPA",
    course: "Data Analytics",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: true,
  },

  {
    id: "P010",
    name: "E. Venkata Harish",
    image: "/images/PlacedStudents2/venkata_harish.png",
    company: "Capgemini",
    companyLogo: "/images/PlacedStudents2/capgemini.png",
    role: null,
    package: "₹8 LPA",
    course: "Java Full Stack",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P006",
    name: "Mohammed Irfan",
    image: "/images/PlacedStudents/mohammed_irfan.png",
    company: "Amazon",
    companyLogo: "/images/PlacedStudents/Amazon.png",
    role: null,
    package: "₹6 LPA",
    course: "Python Full Stack",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P012",
    name: "M. Gowrisankar",
    image: "/images/PlacedStudents2/gowrisankar.png",
    company: "Global Smart Technologies",
    companyLogo: "/images/PlacedStudents2/global_smart_technologies.png",
    role: "Database Administrator",
    package: "₹6 LPA",
    course: "Microsoft .Net Web Application Development",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P005",
    name: "M. Devaharsha",
    image: "/images/PlacedStudents/devaharsha.png",
    company: "PV Tech Solutions",
    companyLogo: "/images/PlacedStudents/PV_Tech_Solutions.png",
    role: null,
    package: "₹4 LPA",
    course: "Java Full Stack",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P001",
    name: "A. Harsha Vardhan",
    image: "/images/PlacedStudents/harsha_vardhan.png",
    company: "IndusInd Bank",
    companyLogo: "/images/PlacedStudents/Indusind_Bank.png",
    role: null,
    package: "₹3.5 LPA",
    course: "Python Full Stack",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P007",
    name: "P. Umadevi",
    image: "/images/PlacedStudents/umadevi.png",
    company: "TCS",
    companyLogo: "/images/PlacedStudents/TCS.png",
    role: null,
    package: "₹3.5 LPA",
    course: "Java Full Stack",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P011",
    name: "Jyothi",
    image: "/images/PlacedStudents2/jyothi.png",
    company: "Praanaa Pain Clinic",
    companyLogo: "/images/PlacedStudents2/praanaa_pain_clinic.png",
    role: null,
    package: "₹3.5 LPA",
    course: "Digital Marketing",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P002",
    name: "A.S. Kavya Sree",
    image: "/images/PlacedStudents/kavya_sree.png",
    company: "D-Mart",
    companyLogo: "/images/PlacedStudents/D_Mart.png",
    role: "Purchase Officer",
    package: "₹3.0 LPA",
    course: "Data Analytics",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P008",
    name: "Y. Nagini",
    image: "/images/PlacedStudents/nagini.png",
    company: "HDB Financial Services",
    companyLogo: "/images/PlacedStudents/HDB_Financial_Services.png",
    role: null,
    package: "₹3.0 LPA",
    course: "Java Full Stack",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P009",
    name: "B. Devika",
    image: "/images/PlacedStudents2/b_devika.png",
    company: "Cognizant",
    companyLogo: "/images/PlacedStudents2/cognizant.png",
    role: null,
    package: "₹3.0 LPA",
    course: "Data Analytics",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P004",
    name: "G. Uday Kiran",
    image: "/images/PlacedStudents/uday_kiran.png",
    company: "Cognizant",
    companyLogo: "/images/PlacedStudents/Cognizant.png",
    role: null,
    package: "₹2.7 LPA",
    course: "Java Full Stack",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P013",
    name: "S. Shruthi",
    image: "/images/PlacedStudents2/s_shruthi.png",
    company: "1 Point 1 Solutions Ltd",
    companyLogo: "/images/PlacedStudents2/one_point_one.png",
    role: null,
    package: "₹2.5 LPA",
    course: "Digital Marketing",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },

  {
    id: "P014",
    name: "T. Vidyasri",
    image: "/images/PlacedStudents2/t_vidyasri.png",
    company: "Invicta Career Consultancy Pvt Ltd",
    companyLogo: "/images/PlacedStudents2/invicta.png",
    role: null,
    package: "₹2.5 LPA",
    course: "Digital Marketing",
    year: null,
    location: null,
    verified: true,
    isSample: false,
    published: true,
    featured: false,
  },
];

export const placementConfig = {
  mode: "live",
  showDemoNotice: false,
};

export default placedStudents;